import React from 'react';

import { formatNumberAsCurrency } from './helpers';
import * as styles from './ItemizedResults.module.scss';

export default function ItemizedResults({ results }) {
  const { conversionIncrease, orderValueIncrease, repeatCustomersIncrease, totalIncrease } = results;

  return (
    <div className={styles.results}>
      <h3>Your profit potential with behavioral data</h3>
      <div className={styles.grid}>
        <p>
          Profit increase from <b>improved conversion rate</b>:
        </p>
        <p className={styles.currency}>{formatNumberAsCurrency(conversionIncrease)}</p>
      </div>
      <div className={styles.grid}>
        <p>
          Profit increase from <b>higher average order value</b>:
        </p>
        <p className={styles.currency}>{formatNumberAsCurrency(orderValueIncrease)}</p>
      </div>
      <div className={styles.grid}>
        <p>
          Profit increase from <b>more repeat customers</b>:
        </p>
        <p className={styles.currency}>{formatNumberAsCurrency(repeatCustomersIncrease)}</p>
      </div>
      <div className={styles.divider} />
      <div className={[styles.grid, styles.total].join(' ')}>
        <p>Total profit increase:</p>
        <p className={styles.currency}>{formatNumberAsCurrency(totalIncrease)}</p>
      </div>
    </div>
  );
}
